// Shared human-readable formatters for dates and addresses - the backend
// gives us raw DateField/TimeField/DateTimeField strings (down to
// microseconds for auto_now_add TimeField), which is not what an operator
// scanning a table wants to read.

const DATE_OPTS = { day: "numeric", month: "short", year: "numeric" };
const TIME_OPTS = { hour: "numeric", minute: "2-digit" };

// Accepts a "YYYY-MM-DD" DateField string or any Date-parseable value.
export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, DATE_OPTS);
}

// Accepts a "HH:MM:SS[.ffffff]" TimeField string.
export function formatTime(timeStr) {
  if (!timeStr) return "";
  const [h, m] = timeStr.split(":");
  const d = new Date();
  d.setHours(Number(h), Number(m), 0, 0);
  return d.toLocaleTimeString(undefined, TIME_OPTS);
}

// Combines a DateField + TimeField pair (Orders' order_Placment_Date/Time).
export function formatDateTime(dateStr, timeStr) {
  const date = formatDate(dateStr);
  const time = timeStr ? formatTime(timeStr) : "";
  return time ? `${date}, ${time}` : date;
}

// Formats a single DateTimeField/ISO string with both date and time.
export function formatDateTimeIso(isoStr) {
  if (!isoStr) return "—";
  const d = new Date(isoStr);
  if (Number.isNaN(d.getTime())) return isoStr;
  return `${d.toLocaleDateString(undefined, DATE_OPTS)}, ${d.toLocaleTimeString(undefined, TIME_OPTS)}`;
}

// Formats an order/customer Address object into one readable line.
export function formatAddress(address) {
  if (!address) return "—";
  const parts = [
    [address.house_Number, address.street_Number].filter(Boolean).join(", "),
    address.area,
    address.city,
  ].filter(Boolean);
  return parts.join(", ");
}
